import { message } from "antd";
import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, CustomSelect, } from "../../../components";
import { createStuden, getAllGroups } from "../../../redux/VRL/thunks";
import { onEditStudenApi } from "../../../api";

export const AddUser = ({ close, isEditing, nameUser = '', matricula = '', grupo, _idUser }) => {
    console.log(grupo)
    const [selectMateria, setSelectItem] = useState(grupo ? grupo._id : null);
    const { groups, } = useSelector((state) => state.vrlSlice);
    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    const dispatch = useDispatch()

    const updateDataGroups = async () => {
        dispatch(getAllGroups(proyectSelected._id))
    }
    let grupSelected = {}
    if (isEditing) {
        grupSelected = groups.find(item => item.name === grupo)
        console.log(grupSelected)
    }

    const onSubmit = async ({ userName, matricula, FormType }, { setSubmitting, resetForm }) => {

        if (isEditing) {
            // edit 
            console.log('Editing..................')
            console.log({
                _id: _idUser,
                name: userName,
                userId: matricula,
                groupId: selectMateria
            })
            const result = await onEditStudenApi({
                _id: _idUser,
                name: userName,
                userId: matricula,
                groupId: selectMateria
            })
            if (result.status === 0) {
                updateDataGroups()
                close()
            }
        }
        else {
        // CReate
            const response = await dispatch(createStuden({ name: userName, userId: matricula, groupId: selectMateria }));
            console.log(response)
            if (response.status === 0) {
                message.success("El usuario se ha creado con éxito");
                resetForm();
                updateDataGroups()
                close();
            } else {
                if (!response.payload) {
                    message.error("Error en la creacion del usuario, usuario ya existe");
                }
                else {
                    message.error("Error en la creacion del usuario");
                }
            }
        }

    };

    return (
        <Formik
            initialValues={{
                userName: nameUser,
                matricula: matricula,
                FormType: "0",
            }}
            // validationSchema={validationLogin}
            onSubmit={onSubmit}
        >
            {({ handleSubmit, handleChange, values }) => (
                <Form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-[1fr] px-4 h-[300px]">
                        <div className="flex flex-col justify-around h-full  mt-3 ml-2">
                            <div>
                                <span className="mt-4 mb-4 text-base font-medium text-686868">Nombre Completo </span>
                                <span className="text-red-700" >*</span>
                                <Field
                                    className="w-full mt-2 text-[#686868] pb-2 bg-transparent text-sm focus:outline-none border-b border-black focus:border-black placeholder:text-[#cdcdcd]"
                                    type="text"
                                    placeholder="Ingresa el nombre(s) y apellidos"
                                    name="userName"
                                    disabled={values.FormType === "1"}
                                    value={values.userName}
                                    autoComplete="none"
                                />
                            </div>
                            <div>
                                <span className="mt-4 mb-4 text-base font-medium text-686868">N° de empleado</span>
                                <span className="text-red-700" >*</span>
                                {/* <p className={`mb-2 text-base font-medium ${values.FormType === "0" ? "text-[#686868]" : "text-gray-200"} mt-4`}>
                                {proyectSelected._id === '66104d3562bdb94c30339831' ? 'No. empleado' : 'Matrícula'}
                            </p> */}
                                <Field
                                    className="w-full mt-2 text-[#686868] pb-2 bg-transparent text-sm focus:outline-none border-b border-black focus:border-black placeholder:text-[#cdcdcd]"
                                    type="text"
                                    placeholder="Ingresa el número del usuario"
                                    name="matricula"
                                    disabled={values.FormType === "1"}
                                    value={values.matricula}
                                    autoComplete="none"
                                />
                            </div>
                            <div>
                                <span className="mt-4 mb-4 text-base font-medium text-686868">Grupo </span>
                                <span className="text-red-700" >*</span>

                                {groups.length > 0 && (
                                    <CustomSelect
                                        disabled={values.FormType === "1"}
                                        items={groups}
                                        defaultValue={isEditing ? grupSelected._id : null}
                                        label="Asigna un grupo"
                                        change={setSelectItem}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="absolute left-0 bottom-0 h-[40px] pb-8 w-full flex justify-end items-center px-4 pl-4">
                            <Button text="Cancelar" isPrincipal={false} onClick={close} />
                            <div className="w-4"></div>
                            <Button text="Guardar" isPrincipal={true} onClick={handleSubmit} />
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};
